{
  "instances": {
    "auditevents": {
      "audit_log_not_supported_spring_boot_1": "Spring Boot 1.x forrit bjóða enga endurskoðunarannála (audit logs).",
      "event": "Atburður",
      "loading_audit_events": "Endurskoðunaratburðir eru að hlaða…",
      "no_audit_events_found": "Engir endurskoðunaratburðir eru í boði.",
      "principal": "Principal",
      "remote_address": "Remote address",
      "session_id": "Seta Id",
      "timestamp": "Tímapunktur",
      "type": "Gerð",
      "label": "Endurskoðunarannáll"
    }
  }
}
